<template>
	<div class="statement">
		<div class="title">积分明细</div>
		<div class="money">
			<span>{{point}}</span>
			<span class="desc">积分</span>
		</div>
		<div class="logs-box">
			<div class="header">
				<div class="order">说明</div>
				<div class="date">时间</div>
				<div class="pay">积分</div>
			</div>
			<div class="logs">
				<div class="item" v-for="(item,index) in list" :key="index">
					<div class="order">
						<div class="p-name">{{ item.message }}</div>
					</div>
					<div class="date">{{ item.create_time }}</div>
					<div class="pay">{{ item.value }}</div>
				</div>
			</div>
		</div>
		<Page :current="page" :total="total" @on-change="changePage" show-total style="margin-top: 20px;"></Page>
	</div>
</template>

<script>
	import { accountGeneral, accountHistory } from "@/api"
	export default {
		name: 'PointLog',
		components: {

		},
		data() {
			return {
				point: 0,
				page:1,
				total:0,
				list:[],
				size:10
			};
		},
		mounted() {
			accountGeneral().then((res)=>{
				this.point = res.data.point
			})
			this.loadData()
		},
		methods: {
			changePage(page) {
				this.page = page
				this.loadData()
			},
			loadData() {
				accountHistory({type: 'point', page: this.page,size: this.size}).then(response => {
					this.list = response.data.list
					this.total = response.data.count
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.statement{
		width: 950px;
		// height: 744px;
		background: #FFFFFF;
		border: 1px solid #EEEEEE;
		padding: 20px;
		.title{
			font-size: 20px;
			font-family: PingFang SC;
			font-weight: bold;
			color: #333333;
		}
		.money{
			font-size: 32px;
			font-weight: bold;
			color: #0F114A;
			margin: 20px auto;
			display: flex;
			flex-direction: column;
			justify-content: center;
			.desc{
				font-size: 13px;
				color: #666666;
				margin-left: 25px;
			}
		}
		.logs-box{
			width: 910px;
			// height: 520px;
			background: #FFFFFF;
			border: 1px solid #EEEEEE;
			.header{
				height: 40px;
				background: #F5F5F5;
				display: flex;
				align-items: center;
				font-size: 13px;
				color: #333333;
				div{
					padding-left: 20px;
				}
			}
			.header,.logs{
				.order{
					width: 500px;
				}

				.date{
					width: 230px;
				}
				.pay{
					width:180px;
				}
			}
			.logs{
				font-size: 15px;
				color: #666666;
				padding: 20px;
				.item:last-child{
					border: none;
				}
				.item {
					display: flex;
					align-items: center;
					height: 50px;
					border-bottom: 1px solid #DDDDDD;
					div{
						padding-left: 20px;
					}
					.order{
						display: flex;
						align-items: center;
						padding-left: 0px;
						img{
							width: 80px;
							height: 80px;
						}
						.p-name{
							font-size: 15px;
							font-weight: bold;
							line-height: 21px;
							color: #333333;
						}
					}
				}
			}
		}
	}
</style>
